export const environment = {
  production: true,
  apiBaseUrl: 'https://evt-va-acs.agorava.cloud.slb-ds.com',
  isAutomationTesting: false,
  appConfigApiUrl: '',
  identityProviderUrl:'https://p4d.csi.cloud.slb-ds.com/v2',
  identityProviderClientKey: '01912ee052d4d9cf5486600b5aa55cdd',
  identityProviderClientSecret:'b64bf0c612a942e4b043050b14abc415cac0cda1fa5624061',
  identityProviderRedirectUrl: 'https://evt-va-acs.agorava.cloud.slb-ds.com/login/logincallback',
  authType: ''
};
